import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Breadcrumbs, Link, Typography, Container, Box, Grid, Button, TextField } from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';
import CheckIcon from '@material-ui/icons/Check';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import WebcamCapture from './WebcamCapture';
import { useDispatch } from 'react-redux';
import { CreatePMLogs, getPM_planbyId, getPMCheckpointById, getPMLogByPlanId, PMuploadFile } from '../../ReduxStore/PreventiveMaintaince/CreatePMPlan';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const CheckpointDetail = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const pathname = location.pathname.split('/');
    const checkpoint_id = pathname[2];
    const plan_id = pathname[3]
    const asset_id = pathname[4]
    const plan_date = pathname[5]

    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Preventive Maintenance', href: '/preventive-maintenance' },
        { label: 'Plan Overview', href: '/plan-overview' },
        { label: 'Checkpoint Activity', href: `/checkpoint-activity/${plan_id}/${asset_id}/${plan_date}` }
    ];

    const [showWebcam, setShowWebcam] = useState(false);
    const [checkpointActivityDone, setCheckpointActivityDone] = useState(false);
    const [capturedImage, setCapturedImage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [Checkpoit, setCheckpoit] = useState();
    const [log, setLog] = useState([]);
    // const [plan, setplan] = useState();
    const [observatiob, setObservatiob] = useState("");
    const [formData, setFormData] = useState({
        frequency: "",
        startDate: "",
        assetNo: "",
        assetDes: "",
        partNo: ""
    });
    const [fileName, setFileName] = useState("");
    const [uploadedImgUrl, setUploadedImgUrl] = useState(null);
    const [showUploadedImage, setshowUploadedImage] = useState(false);
    const [imageUrls, setImageUrls] = useState([]);
    const logUser = localStorage.getItem("username")

    // const handleCapture = (imageSrc) => {
    //     setCapturedImage(imageSrc);
    //     setShowWebcam(false);
    //     // Save to local storage
    //     localStorage.setItem('capturedImage', imageSrc);
    //     console.log('Image saved to local storage');
    // };

    const handleCapture = async (imageSrc) => {
        setShowWebcam(false);
        const dataURItoBlob = (dataURI) => {
            const byteString = atob(dataURI.split(',')[1]);
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);

            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }

            return new Blob([ab], { type: mimeString });
        };
        const file = dataURItoBlob(imageSrc)
        const customerID = "30fa3d2e687748999daf40a5a9176e4c"
        const formData = new FormData();
        formData.append('upload_file', file);
        formData.append('customerID', customerID)
        // formData.append('file', file);
        try {
            const action = dispatch(PMuploadFile(formData));
            const res = await action.unwrap();
            console.log("res from pv log:", res);
            if (res.StatusCode === 200) {
                setshowUploadedImage(true);
                toast.success("Image Upload Done");
                setUploadedImgUrl(res.response.s3_file_url);
                setFileName(res.response.file_name);
                console.log("imageURL", uploadedImgUrl, fileName)
            } else {
                toast.error("Something went wrong!")
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "Something went wrong!");
        }
    };

    const ngHandler = async () => {
        const log_data = {
            checkpoints: [
                {
                    id: checkpoint_id,
                    ok: false
                }
            ],
            asset_id: asset_id,
            done_by: logUser,
            object_ids: fileName ? [fileName] : [],
            observation: observatiob
        };
        try {
            const action = dispatch(CreatePMLogs(log_data));
            const res = await action.unwrap();
            if (res.StatusCode === 201) {
                getlogs();
                toast.success("Checkpoint Done");
                setTimeout(() => {
                    navigate(`/checkpoint-activity/${plan_id}/${asset_id}/${plan_date}`);
                }, 2000);
            } else {
                toast.error(res.Message || "Something went wrong!");
            }
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    }

    const okHandler = async () => {
        const log_data = {
            checkpoints: [
                {
                    id: checkpoint_id,
                    ok: true
                }
            ],
            asset_id: asset_id,
            done_by: logUser,
            object_ids: fileName ? [fileName] : [],
            observation: observatiob
        };
        try {
            const action = dispatch(CreatePMLogs(log_data));
            const res = await action.unwrap();
            if (res.StatusCode === 201) {
                getlogs();
                toast.success("Checkpoint Done");
                setTimeout(() => {
                    navigate(`/checkpoint-activity/${plan_id}/${asset_id}/${plan_date}`);
                }, 2000);
            } else {
                toast.error(res.Message || "Something went wrong!");
            }
        } catch (error) {
            toast.error(error.message || "Failed to create PM log!");
        }
    };

    const getlogs = async () => {
        try {
            const action = dispatch(getPMLogByPlanId({ plan_id: plan_id, plan_date: plan_date }));
            const res = await action.unwrap();
            console.log("log response:", res);
            // setLogs(res.result.pm_logs);
            const logs = res.result.pm_logs
            const matchingLog = logs.find(log => log.checkpoint_id === checkpoint_id);
            console.log("Matching Log:", matchingLog);
            setLog(matchingLog)

            if (matchingLog && matchingLog.hasOwnProperty('point_ok')) {
                setCheckpointActivityDone(true);
            } else {
                setCheckpointActivityDone(false);
            }

            const allUrls = res.result.pm_logs
                .map(log => log.all_URLs)
                .flat() // Flatten the array if there are nested arrays
                .filter(url => typeof url === 'string');
            console.log("All url:", allUrls)

            if (allUrls.length > 0) {
                console.log("check urls--------", allUrls)
                setImageUrls(allUrls);
                setshowUploadedImage(true);
            }

        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    };

    const getPlanbyId = async () => {
        try {
            const action = dispatch(getPM_planbyId(plan_id));
            const res = await action.unwrap();
            if (res.result) {
                // setplan(res.result.pm_plan[0]);
                setFormData({
                    ...formData,
                    frequency: res.result.pm_plan[0].frequency,
                    startDate: res.result.pm_plan[0].start_date,
                    assetNo: res.result.pm_plan[0].assetMaster_details.asset_no,
                    assetDes: res.result.pm_plan[0].assetMaster_details.asset_text,
                    partNo: res.result.pm_plan[0].assetMaster_details.material_no

                });
            };
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
        // console.log("plan fetched:", pmPlan)
    }
    const getCheckpointyId = async () => {
        try {
            const action = dispatch(getPMCheckpointById(checkpoint_id));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                setCheckpoit(res.result.pm_checkpoints)
            };
        } catch (error) {
            toast.error(error.message || "Something went wrong!");
        }
    }

    useEffect(() => {
        // getPlanbyId();
        // getCheckpointyId();
        const fetchData = async () => {
            await getPlanbyId();
            await getlogs();
            await getCheckpointyId();
            setLoading(false);
        };
        fetchData();
    }, [plan_id, checkpoint_id]);

    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Checkpoints Details" />
                </Box>
                {/* <Box style={{ margin: '0 auto', maxWidth: '850px', padding: '20px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                            >
                                Checkpoint Activity
                            </Button>
                        </Grid>
                        <Grid item xs={1}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                style={{ color: "black", background: "white" }}
                            >
                                Skip

                            </Button>
                        </Grid>
                    </Grid>
                </Box> */}
                {/* <Box className="checkpoint-box" mb={3}>
                    {Checkpoit && Checkpoit.map((item, index) => (
                        <>
                            <Grid container spacing={2} key={index}>
                                <Grid item xs={6} sm={2}>
                                    Checkpoint
                                    <h4>{item.check_point}</h4>
                                </Grid>
                                <Grid item xs={6} sm={5}>
                                    Asset
                                    <h4>{formData.assetDes}({formData.assetNo})</h4>
                                </Grid>
                                <Grid item xs={6} sm={2}>
                                    RFID NO
                                </Grid>
                                <Grid item xs={6} sm={2}>
                                    Part No
                                    <h4>{formData.partNo}</h4>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6} sm={2}>
                                    Frequency
                                    <h4>{formData.frequency}</h4>
                                </Grid>
                                <Grid item xs={6} sm={2}>
                                    Start Date
                                    <h4>{formData.startDate}</h4>
                                </Grid>
                                <Grid item xs={6} sm={2}>
                                    <p>Enabled</p>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={item.active}
                                                name="enabled"
                                                color="primary"
                                            />
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </>

                    ))}

                </Box> */}
                <Box className="checkpoint-box" mb={3}>

                    {/* <Box
                                mb={2}
                                p={2}
                                style={{
                                    backgroundColor: item.point_ok ? 'green' : 'red',
                                    color: 'white',
                                    borderRadius: '4px',
                                }}
                            >
                                <Typography variant="h6">
                                    Checkpoint Status: {item.point_ok ? 'OK' : 'NG'}
                                </Typography>
                            </Box> */}
                    <Box mb={2}>
                        <Typography variant="h6">
                            Checkpoint Status:
                            <span
                                style={{
                                    backgroundColor: log.hasOwnProperty('point_ok') ? (log.point_ok ? 'green' : 'red') : 'gray',
                                    color: 'white',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    marginLeft: '8px',
                                }}
                            >
                                {/* {log.point_ok ? 'OK' : 'NG'} */}
                                {log.hasOwnProperty('point_ok')
                                    ? (log.point_ok ? 'OK' : 'NG')
                                    : 'Not Done'}
                            </span>
                        </Typography>
                    </Box>

                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={2}>
                            Checkpoint
                            <h4>{log.check_point}</h4>
                        </Grid>
                        <Grid item xs={12} sm={5}>
                            Asset
                            <h4>{formData.assetDes}({(formData.assetNo).slice(3)})</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            RFID NO
                            {/* <h4>{rfidNo}</h4> */}
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Part No
                            <h4>{formData.partNo}</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={2}>
                            Frequency
                            <h4>{formData.frequency}</h4>
                        </Grid>
                        <Grid item xs={6} sm={2}>
                            Start Date
                            <h4>{formData.startDate}</h4>
                        </Grid>
                        {/* <Grid item xs={6} sm={2}>
                                    <p>Enabled</p>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={log.active}
                                                name="enabled"
                                                color="primary"
                                            />
                                        }
                                    />
                                </Grid> */}
                    </Grid>
                </Box>

                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            Take Pictures
                            <h4>Please specify the checkpoint as OK or NG first</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={3}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => setShowWebcam(true)}
                                disabled={checkpointActivityDone}
                            >
                                Start
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                <Box className="checkpoint-box" mb={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            Observation
                            <h4>Comment your Observation</h4>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={10}>
                            <TextField
                                label="Observation"
                                name="Observation"
                                type="text"
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={3}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onChange={(e) => setObservatiob(e.target.value)}
                                disabled={checkpointActivityDone}
                            />
                        </Grid>
                    </Grid>
                </Box>
                {showWebcam && (
                    <Box className='checkpoint-box' mb={2}>
                        <WebcamCapture onCapture={handleCapture} />
                    </Box>
                )}
                {showUploadedImage && (
                    <Box className='checkpoint-box' mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} sm={6}>
                                <h4>Uploaded Images</h4>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            {imageUrls && imageUrls.length > 0 ? (
                                imageUrls.map((url, index) => (
                                    <Grid item xs={6} sm={6} key={index}>
                                        <img src={url} alt={`Uploaded ${index + 1}`} width="100%" />
                                    </Grid>
                                ))
                            ) : (<Grid item xs={6} sm={6}>
                                <img src={uploadedImgUrl} alt="Uploaded" width="100%" />
                            </Grid>
                            )}
                        </Grid>
                    </Box>
                )}
                <Box style={{ margin: '0 auto', maxWidth: '850px', marginBottom: "10px" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={6} sm={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px" }}
                                startIcon={<NotInterestedIcon />}
                                onClick={ngHandler}
                            >
                                NG
                            </Button>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                style={{ borderRadius: "8px", fontSize: "16px" }}
                                startIcon={<CheckIcon />}
                                onClick={okHandler}
                            >
                                OK
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    );
};

export default CheckpointDetail;
